<template>
	<widget title="Schedule Defaults" class="row-padding">
		<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

		<vue-form v-on:submit="save" :no-top-button="true">

			<form-group label="Work Day"
				col-class="col-md-4">

				<div class="d-flex">
					<field class="mr-4"
						:params="{
							type: 'time'
						}"
						v-model="settings.workdayStartTime">		
					</field>

					<field label="To"
						col-class="col-auto"
						:params="{
							type: 'time'
						}"
						v-model="settings.workdayEndTime">		
					</field>
				</div>
			</form-group>

			<field label="Default Service Job Duration (hrs)"
				col-class="col-md-4"
				:params="{
					type: 'number',
					step: 0.25,
					min: 0.5
				}"
				v-model="settings.serviceJobDurationHrs">		
			</field>

			<field label="Default View"
				col-class="col-md-4"
				:params="{
					type: 'select',
					options: [
						{text: 'Daily', value:'daily'},
						{text: 'Weekly', value:'weekly'},
						{text: 'Monthly', value:'monthly'}
					]
				}"
				v-model="settings.defaultView">		
			</field>

			<form-group label="Default Event Types Filters"
				col-class="col-md-4">

				<field label="Daily View"
					col-class="col-auto"
					:params="{
						type: 'select-multi',
						closeOnSelect:false,
						options: typeFilterOptions
					}"
					v-model="settings.defaultTypeFiltersDaily">		
				</field>

				<field label="Weekly View"
					col-class="col-auto"
					:params="{
						type: 'select-multi',
						closeOnSelect:false,
						options: typeFilterOptions
					}"
					v-model="settings.defaultTypeFiltersWeekly">		
				</field>

				<field label="Monthly View"
					col-class="col-auto"
					:params="{
						type: 'select-multi',
						closeOnSelect:false,
						options: typeFilterOptions
					}"
					v-model="settings.defaultTypeFiltersMonthly">		
				</field>

			</form-group>

			<h4>Display Fields on Event Tiles</h4>

			<field label="Daily View (max 2)"
				col-class="col-md-4"
				:params="{
					type: 'checklist',
					options: [
						{text: 'Entity Name',value:'entityName'},
						{text: 'Start & End Time',value:'startEndTime'},
						{text: 'Customer Name',value: 'customerName'},
						{text: 'Location Address',value: 'locationAddress'}
					]
				}"
				v-model="settings.eventTileDisplayFieldsDaily"
				v-on:change="dailyViewDisplayFieldsChange">	
				<hr>	
			</field>



			<field label="Weekly & Monthly Views"
				col-class="col-md-4"
				:params="{
					type: 'checklist',
					options: [
						{text: 'Entity Name',value:'entityName'},
						{text: 'Start & End Time',value:'startEndTime'},
						{text: 'Customer Name',value: 'customerName'},
						{text: 'Location Address',value: 'locationAddress'}
					]
				}"
				v-model="settings.eventTileDisplayFields">		
			</field>

			<field label="Enforce Conflicts"
				col-class="col-md-4"
				:params="{
					type: 'boolean',
				}"
				v-model="settings.enforceConflicts">

				<div class="text-muted">Turning this on will prevent any event that conflicts with another event to be saved. If this setting is turned off, conflicting events will be allowed.</div>

			</field>

			<!--
			<field label="Events should default as Priority Events"
				col-class="col-md-4"
				:params="{
					type: 'boolean',
				}"
				v-model="settings.defaultToPriorityEvents">

				<div class="text-muted">Priority events are events that are to be completed in order of priority, and do not necessarily need to occur at the specified start time.</div>

			</field>
			-->

		</vue-form>
	</widget>
</template>
<script type="text/javascript">
import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

import Widget from "@/components/Widget"

export default {
	name: "ScheduleSettings",
	components: {
		Field,
		Widget,
		VueForm,
		FormGroup,
		FreemiumLockedAlert
	},
	data() {
		return {
			settingKeys: {},
			test: [],
			settings: {
				defaultView: "daily",
				defaultTypeFiltersDaily: ["project","service"],
				defaultTypeFiltersWeekly: ["project","service"],
				defaultTypeFiltersMonthly: ["project","service"],
				eventTileDisplayFields: [],
				eventTileDisplayFieldsDaily: [],
				enforceConflicts: false,
				dayStartTime: "08:00",
				dayEndTime: "17:00",
				//defaultToPriorityEvents: false,
				serviceJobDurationHrs: 1
			},
			typeFilterOptions: [
				{text: 'Project Events',value:'project'},
				{text: 'Service Events',value:'service'},
				{text: 'Equipment Events',value: 'equipment'},
				{text: 'Equipment Servicing Events',value: 'equipment-servicing'},
				{text: 'Employee Events',value: 'user'}
			]
		}
	},
	watch: {
		'$store.company'() {
			if ("CompanySetting" in this.$store.company)
				this.setSettings()
		}
	},
	methods: {
		setSettings() {
			this.settings = JSON.parse(this.$store.company.CompanySetting.schedule_defaults_json)
			
			//initialize the missing keys as empty values
			Object.keys(this.settingKeys).forEach(key => {


				if (!(key in this.settings)) {
					if (typeof this.settingKeys[key] == 'string')
						this.settings[key] = ""
					else if (typeof this.settingKeys[key] == 'object')
						this.settings[key] = []
					else
						this.settings[key] = false
				}
			})

			//initialize values if they don't exist yet
			if (!this.settings.eventTileDisplayFieldsDaily)
				this.settings.eventTileDisplayFieldsDaily = []

			if (!this.settings.eventTileDisplayFields)
				this.settings.eventTileDisplayFields = []
		},
		dailyViewDisplayFieldsChange(value) {
			//make sure only max 2 can be selected
			if (value.length > 2) {
				//drop the first value
				value = value.shift()
			}
		},
		save() {
			let vm = this

			let payload = {
				schedule_defaults_json: JSON.stringify(this.settings)
			}

			this.postData("CompanySetting/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Schedule settings saved!")
				}
			})
		}
	},
	created() {
		//store the settings key so we can initialize them as required
		Object.keys(this.settings).forEach(key => {
			this.settingKeys[key] = typeof this.settings[key]
		})

		if ("CompanySetting" in this.$store.company) {
			this.setSettings()
		}
	}
}
</script>